import React from "react";
import { TextField } from "@mui/material";

import LiveUserAvatar from "./LiveUserAvatar";
import ConnectForm from "../../../../components/helper/ConnectForm";

import UserVerified from "../../../../images/icons/user_verified.svg?react";
import Location from "../../../common/Location";

export default function LiveSendTipCard({ data }) {
  return (
    <>
      <ConnectForm>
        {({ register, formState: { errors }, setValue }) => (
          <div className="d-flex w-100 flex-column">
            <div className="user-section">
              <div className="avatar-container">
                <div className="avatar-container">
                  <LiveUserAvatar
                    className="border-0"
                    alt="user_profile"
                    src={data?.user?.picture}
                  />
                </div>
                <div className="user-details d-flex flex-column">
                  <div className="username w-100">
                    <p className="username-text p-0">
                      {data?.user?.name} <UserVerified />
                    </p>
                    <p className="username-link">
                      {/* @{data?.user?.username} */}
                      <Location city={data?.user?.city} country={data?.user?.country} />
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 end-modal-body stream-tip">
              <div className="form-group">
                <TextField
                  label="Enter Amount"
                  variant="outlined"
                  fullWidth={true}
                  focused={true}
                  placeholder="Enter tip amount"
                  error={!!errors.amount}
                  InputLabelProps={{
                    className: "bg-white-input-label",
                    style: {
                      color: "black !important",
                    },
                  }}
                  type="number"
                  helperText={errors.amount ? errors.amount.message : null}
                  {...register("amount", {
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    min: {
                      value: 1,
                      message: "The minimum tip amount should be $1",
                    },
                  })}
                />
              </div>
              <div className="form-group mt-3">
                <div className="d-flex flex-row">
                  <div
                    data-testid="dollar-10"
                    onClick={() => setValue("amount", 1)}
                    role={"button"}
                    aria-label="amount"
                    className="p-0 tip-button"
                  >
                    $1
                  </div>
                  <div
                    onClick={() => setValue("amount", 5)}
                    role={"button"}
                    aria-label="amount"
                    className="p-0 tip-button"
                  >
                    $5
                  </div>
                  <div
                    onClick={() => setValue("amount", 15)}
                    role={"button"}
                    aria-label="amount"
                    className="p-0 tip-button"
                  >
                    $15
                  </div>
                  <div
                    onClick={() => setValue("amount", 20)}
                    role={"button"}
                    aria-label="amount"
                    className="p-0 tip-button"
                  >
                    $20
                  </div>
                </div>
              </div>
              <div className="form-group mt-3">
                <TextField
                  label="Message"
                  variant="outlined"
                  className="text-area-input"
                  fullWidth={true}
                  multiline
                  maxRows={8}
                  rows={3}
                  placeholder="Message (optional)"
                  InputLabelProps={{
                    className: "bg-white-input-label",
                    style: {
                      color: "black !important",
                    },
                  }}
                  error={!!errors?.message}
                  helperText={errors?.message ? errors.message.message : null}
                  {...register("message", {})}
                />
              </div>
            </div>
          </div>
        )}
      </ConnectForm>
    </>
  );
}
